


































import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import SelectiveProcessService from '@/domain/selective-process/service/selective-process.service';
import { VbSnackbarService } from 'bag-of-holding-library';

@Component({
  components: {
    LabelSlot,
    ModalComponent,
  },
})
export default class ImportCandidateModal extends Vue {
  @Prop() openModal!: boolean;

  loading: boolean = false;

  jobId: string = '';

  candidateId: string = '';

  get optionsHandled(): ModalOptions {
    return {
      title: 'Importar Candidato',
      titleSize: '20px',
      description: '',
      showOk: true,
      labelOk: 'importar',
      loadingOk: this.loading,
      disabledOk: false,
      showCancel: true,
      labelCancel: 'fechar',
      width: 500,
    };
  }

  closeModal(event: any) {
    this.jobId = '';
    this.candidateId = '';
    this.$emit('closeModal', event);
  }

  async importCandidate() {
    this.loading = true;
    await SelectiveProcessService.forceImportCandidate(this.jobId, this.candidateId)
      .then(() => {
        this.closeModal(false);
        VbSnackbarService.showSuccess('Candidato importado com sucesso!');
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
